module.exports = __webpack_public_path__ + "static/media/fal_fal_sit_spe_met.20419508.png";